import React, { createContext, useState } from "react";

export const LayoutContext = createContext({
    sidebarOpen: false,
    setSidebarOpen: () => {},
    toggleSidebar: () => {},
    layoutType: "vertical",
    setLayoutType: () => {},
    theme: "light",
    setTheme: () => {}
});

export const LayoutProvider = ({ children }) => {
    // Default values
    // Inicia aberto apenas se a tela for de desktop
    const [sidebarOpen, setSidebarOpen] = useState(window.innerWidth >= 992);
    const [layoutType, setLayoutType] = useState("vertical");
    const [theme, setTheme] = useState("light");

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const value = {
        sidebarOpen,
        setSidebarOpen,
        toggleSidebar,
        layoutType,
        setLayoutType,
        theme,
        setTheme
    };

    return (
        <LayoutContext.Provider value={value}>
            {children}
        </LayoutContext.Provider>
    );
};
